import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useGlobalContext } from '../../context/GlobalContext';

const Header = () => {
  const { globalSettings: settings } = useGlobalContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Projects', path: '/projects' },
    { name: 'Blog', path: '/blog' },
    { name: 'Resume', path: '/resume' },
    { name: 'Contact', path: '/contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-smooth ${
        isScrolled 
          ? 'bg-background/80 backdrop-blur-md shadow-card border-b border-white/5' 
          : 'bg-background/50 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center space-x-2 group"
            onClick={closeMenu}
          >
            <div className="w-8 h-8 lg:w-10 lg:h-10 bg-primary rounded-lg flex items-center justify-center transition-smooth group-hover:bg-accent">
                  <img
                  src={settings?.about_hero_pic || "/assets/images/Sudhan_2026_v3.png"} // Now powered globally!
                  alt="Sudhan R Portfolio Logo"
                  width={42.5}
                  height={42.5}
                  className="object-contain rounded-lg"
                />
            </div>
            <span className="font-heading font-semibold text-lg lg:text-xl text-text-primary group-hover:text-accent transition-smooth">
              Sudhan R
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative font-body font-medium text-sm xl:text-base transition-smooth hover:text-accent ${
                  isActivePath(item.path)
                    ? 'text-text-primary' :'text-text-secondary'
                }`}
              >
                {item.name}
                {isActivePath(item.path) && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-accent rounded-full"></span>
                )}
              </Link>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <Link
              to="/contact"
              className="bg-error hover:bg-error-600 text-white font-heading font-semibold px-6 py-2.5 rounded-lg transition-smooth shadow-subtle hover:shadow-primary transform hover:-translate-y-0.5"
            >
              Let's Talk
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden p-2 rounded-lg text-text-secondary hover:text-text-primary hover:bg-white/10 transition-smooth"
            aria-label="Toggle menu"
          >
            <Icon 
              name={isMenuOpen ? "X" : "Menu"} 
              size={24} 
            />
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`lg:hidden transition-smooth overflow-hidden ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <nav className="py-4 border-t border-border-muted">
            <div className="flex flex-col space-y-1">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMenu}
                  className={`px-4 py-3 rounded-lg font-body font-medium transition-smooth ${
                    isActivePath(item.path)
                      ? 'text-text-primary bg-white/10 border-l-4 border-accent' :'text-text-secondary hover:text-text-primary hover:bg-white/5'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="px-4 pt-4">
                <Link
                  to="/contact"
                  onClick={closeMenu}
                  className="block w-full text-center bg-error hover:bg-error-600 text-white font-heading font-semibold px-6 py-3 rounded-lg transition-smooth"
                >
                  Let's Talk
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;